import { render, staticRenderFns } from "./UniversityTypeIndex.vue?vue&type=template&id=71e740a2&scoped=true&"
import script from "./UniversityTypeIndex.vue?vue&type=script&lang=js&"
export * from "./UniversityTypeIndex.vue?vue&type=script&lang=js&"
import style0 from "./UniversityTypeIndex.vue?vue&type=style&index=0&id=71e740a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e740a2",
  null
  
)

export default component.exports